var map = {
	"./brand-logo.svg": "H66i",
	"./lock.svg": "FnAU",
	"./menu-about.svg": "pEdS",
	"./menu-add.svg": "ra8C",
	"./menu-admin.svg": "0iGf",
	"./menu-awards.svg": "Ecvo",
	"./menu-business.svg": "5FV1",
	"./menu-home.svg": "pXsZ",
	"./menu-list.svg": "55N9",
	"./menu-mail.svg": "0wZm",
	"./menu-menu.svg": "JfvO",
	"./menu-permission.svg": "FrAW",
	"./menu-portal.svg": "uNQi",
	"./menu-resource.svg": "ijoa",
	"./menu-role.svg": "b5TC",
	"./menu-share.svg": "S27b",
	"./menu-social.svg": "O0Iv",
	"./menu-system.svg": "iwA/",
	"./menu-works.svg": "21+S",
	"./nav-menu.svg": "PJ5R",
	"./tiger-brand-logo.svg": "yI6i",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 28